module.exports = "pegasus/assets/column-2-basic.png";